import {useEffect, useState} from "react";
import {
	CollapsibleMenu,
	MenuItem,
} from "../_components/layout/MobileMenu/MenuTypes";
import {makeCampusInfoUrl, makeCampusTuitionUrl} from "./dynamicUrlUtils";
import {useCampusContext} from "../_components/contexts/CampusCookieContext";

/**
 * static URLs to append at the end of the campus menu.  currently none but
 * leaving this here for posterity
 **/
const STATIC_CAMPUS_MENU_ITEMS: MenuItem[] = [];

export interface UseCampusNavItemConfig {
	campusLabelComponent?: React.ReactElement;
	loadingComponent?: React.ReactElement;
}

const getCampusMenuItems = (campusId?: string | null) => {
	if (!campusId) {
		return [];
	}

	return [
		{
			label: "Campus Information",
			href: makeCampusInfoUrl(campusId),
			id: "campus-info",
		},
		{
			label: "Tuition",
			href: makeCampusTuitionUrl(campusId),
			id: "tuition",
		},
		...STATIC_CAMPUS_MENU_ITEMS,
	];
};

/**
 * Hook which returns values used to populate the campus item in the navbar.
 *
 * Fetches from Strapi.
 */
export const useCampusNavItem = (config: UseCampusNavItemConfig = {}) => {
	const {campus, isLoading: isFetchingCampus} = useCampusContext();
	const [campusNavItemProps, setCampusNavItemProps] =
		useState<CollapsibleMenu | null>(null);
	useEffect(() => {
		const campusMenuItems = getCampusMenuItems(campus?.campusId);
		if (isFetchingCampus) {
			setCampusNavItemProps({
				label: config.loadingComponent,
				id: "campus-dropdown",
				menuItems: campusMenuItems,
			});
			return;
		}

		if (!campus?.campusId || !campus) {
			setCampusNavItemProps(null);
			return;
		}

		setCampusNavItemProps((loadingCampusNavItem) => {
			if (!loadingCampusNavItem) {
				return null;
			}
			return {
				...loadingCampusNavItem,
				menuItems: campusMenuItems,
				label: config.campusLabelComponent,
			};
		});
	}, [
		campus,
		isFetchingCampus,
		config.campusLabelComponent,
		config.loadingComponent,
	]);

	return {campusNavItemProps, campus, isFetchingCampus};
};
